import { Component } from 'react';
import { connect } from 'react-redux';

class DeveloperDashboard extends Component {
  componentWillMount() {
    this.props.history.push('/add-strings');
  }

  render() {
    return null;
  }
}

export default connect()(DeveloperDashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard/developerDashboard/index.js